module.exports = __webpack_public_path__ + "static/media/19 Whizzer.18aea0eb.jpg";